module.exports = __webpack_public_path__ + "static/media/Celeb1.22e1ba63.jpg";